import { CSS_VARIABLES } from '../index';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function isCssVariablesFeatureEnabled() {
    return isFeatureEnabled(CSS_VARIABLES);
}
